import React from 'react';
import Tooltip from '../components/Tooltip';
import Header from '../components/Header';
import Footer from '../components/Footer';

import {
  Info,
  Star
} from '@phosphor-icons/react';
const TooltipTest = () => {
  return (
    <div className="min-h-screen bg-[#161B26]">
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-white mb-8">Tooltip Component Test</h1>
          
          {/* Test 1: Info Icon with Tooltip */}
          <div className="glass rounded-3xl p-8 mb-8">
            <div className="flex items-center gap-2 mb-4">
              <h2 className="text-2xl font-bold text-white">Test 1: Info Icon</h2>
              <Tooltip text="This is a tooltip with an Info icon. It should appear above all content.">
                <Info size={18} className="text-[#718096] cursor-help" />
              </Tooltip>
            </div>
            <p className="text-[#A0AEC0]">Hover over the info icon to see the tooltip.</p>
          </div>
          
          {/* Test 2: Disabled Button with Tooltip */}
          <div className="glass rounded-3xl p-8 mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">Test 2: Disabled Button</h2>
            <Tooltip text="This button is disabled. Upgrade to Pro to unlock this feature.">
              <button
                disabled
                className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[rgba(255,255,255,0.05)] text-[#718096] cursor-not-allowed opacity-60"
              >
                <Star size={16} />
                <span className="text-sm">Action Plan</span>
              </button>
            </Tooltip>
            <p className="text-[#A0AEC0] mt-4">Hover over the disabled button to see the tooltip.</p>
          </div>
          
          {/* Test 3: Layersed Cards */}
          <div className="glass rounded-3xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Test 3: Layersed Cards</h2>
            
            <div className="space-y-4">
              <div className="p-6 rounded-2xl glass">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-white">Card 1</h3>
                  <Tooltip text="This is the first card's tooltip. It should render above all other cards.">
                    <Info size={18} className="text-[#718096] cursor-help" />
                  </Tooltip>
                </div>
                <p className="text-[#A0AEC0]">Hover over the icon to test tooltip visibility.</p>
              </div>
              
              <div className="p-6 rounded-2xl glass">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-white">Card 2</h3>
                  <Tooltip text="This is the second card's tooltip. It should still be visible above everything.">
                    <Info size={18} className="text-[#718096] cursor-help" />
                  </Tooltip>
                </div>
                <p className="text-[#A0AEC0]">This card is below Card 1 but tooltip should still work.</p>
              </div>
              
              <div className="p-6 rounded-2xl glass">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-white">Card 3</h3>
                  <Tooltip text="This is the third card's tooltip. Still fully visible!">
                    <Info size={18} className="text-[#718096] cursor-help" />
                  </Tooltip>
                </div>
                <p className="text-[#A0AEC0]">Even on the third card, tooltips work perfectly.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TooltipTest;
